/* *
 *
 * @author whiteshader@163.com
 * @datetime  2022/02/15
 *
 * */

import RightContent from '@/components/RightContent';
import type { Settings as LayoutSettings } from '@ant-design/pro-layout';
import { PageLoading } from '@ant-design/pro-layout';
// import { getMatchMenuItem } from "./services/session";
import zhCN from 'antd/es/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import type { RunTimeLayoutConfig } from 'umi';
import { history } from 'umi';
import defaultSettings from '../config/defaultSettings';
import { getAccessToken, setSessionToken, setIframeToken } from './access';
import Logo from './assets/image/logo.png';
import NoAccess from './pages/exception/403/index';
import { getRoutersInfo, getUserInfo, getAIUserId } from './services/session';
import { useGlobal } from '@/store/global';
import WsRequest from './utils/WsRequest';
moment.locale('zh-cn');

// const isDev = process.env.NODE_ENV === 'development';
const loginPath = '/user/login';
// const ssoLoginPath = SSOServer ? `${SSOServer}/login` : '';
// const resetPwdPath = '/user/reset-pwd';
const depaths = [
  '/user/login',
  '/user/reset-pwd',
  '/user/register',
  '/user/login/',
  '/user/reset-pwd/',
  '/user/register/',
];
const noMenus = ['/user/login', '/user/reset-pwd', '/user/register', '/account/center'];

async function sso() {
  const params = new URLSearchParams(window.location.search.substr(1));
  const token = params.get('token') || '';
  if (token) {
    // localStorage.clear();
    // localStorage.setItem('access_token', token!);
    const current = new Date();
    const expireTime = current.setTime(current.getTime() + 1000 * 12 * 60 * 60);
    setSessionToken(token, token, expireTime);
    setIframeToken(token || '');
  }
}

/** 获取用户信息比较慢的时候会展示一个 loading */
export const initialStateConfig = {
  loading: <PageLoading />,
};

/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser;
  loading?: boolean;
  fetchUserInfo?: () => Promise<API.CurrentUser | undefined>;
  fetchMenuInfo?: () => Promise<any>;
  ws: WsRequest;
  menus?: any;
}> {
  const fetchUserInfo = async () => {
    try {
      const resp = await getUserInfo();
      if (resp === undefined || resp.code !== '00000') {
        history.push(loginPath);
        // window.location.href = ssoLoginPath
      } else {
        const token = getAccessToken();
        const res = await getAIUserId({token})
        if (res === undefined || res.code !== 0 || !res?.data?.userStr) {
          return { ...resp?.data?.user, userStr: '', permissions: resp?.data?.permissions } as API.CurrentUser;
        } else {
          useGlobal.getState().setAIUserId(res.data.userStr);
          return { ...resp?.data?.user, userStr: res.data.userStr, permissions: resp?.data?.permissions } as API.CurrentUser;
        }
      }
    } catch (error) {
      history.push(loginPath);
      // window.location.href = ssoLoginPath
    }
    return undefined;
  };
  const fetchMenuInfo = async () => {
    try {
      const menu = await getRoutersInfo();
      if (menu === undefined || menu.length === 0) {
        history.push(loginPath);
        // window.location.href = ssoLoginPath
      } else {
        return [...menu];
      }
    } catch (error) {
      history.push(loginPath);
      // window.location.href = ssoLoginPath
    }
    return undefined;
  };
  const ws = new WsRequest();
  // if (SSOServer || window.location.pathname !== '/user/login') {
  //   sso();
  // }
  // 如果是登录、地图页面，不执行
  if (depaths.indexOf(history.location.pathname) === -1 && !location.pathname.startsWith('/charts/map/')) {
    const currentUser = await fetchUserInfo();
    const menus = await fetchMenuInfo();
    const res = await ws.init(`${WS_HOST}?token=${getAccessToken()}`);
    console.log('ws complete', res);
    return {
      settings: defaultSettings,
      currentUser,
      menus,
      fetchUserInfo,
      fetchMenuInfo,
      ws,
    };
  }
  return {
    fetchUserInfo,
    fetchMenuInfo,
    settings: defaultSettings,
    ws,
  };
}

const findPath = (list: any[], joint: any) => {
  if (!list || list.length === 0) return;
  let path: any;
  for (let index = 0; index < list.length; index++) {
    const item = list[index];
    if (item.hasChild === 0 && item.hideInMenu === false) {
      path = joint + item.path;
      break;
    } else if (
      item.hasChild === 1 &&
      item.routes &&
      item.routes.length > 0 &&
      item.hideInMenu === false
    ) {
      // 测试新增
      if (item.path === '/') {
        path = findPath(item.routes, joint + item.path);
      } else {
        path = findPath(item.routes, joint + item.path + '/');
      }
      if (path) {
        break;
      }
    }
  }
  return path;
};
const findMenu = (menus: any[], path: any, parentPath: any) => {
  if (!menus || menus.length === 0) return;
  let ele: any;
  for (let index = 0; index < menus.length; index++) {
    const item = menus[index];
    if (
      parentPath + item.path === path &&
      item.routes &&
      item.routes.length > 0 &&
      item.hideInMenu === false
    ) {
      ele = findPath([item], parentPath);
      if (ele) {
        break;
      }
    } else if (
      parentPath + item.path !== path &&
      item.routes &&
      item.routes.length > 0 &&
      item.hideInMenu === false
    ) {
      ele = findMenu(item.routes, path, parentPath + item.path);
      if (ele) {
        break;
      }
    }
  }
  return ele;
};

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }) => {
  return {
    // contentStyle:{
    //   height: '100%'
    // },
    rightContentRender: () => <RightContent />,
    waterMarkProps: {
      content: initialState?.currentUser?.userName,
    },
    // footerRender: () => <Footer />,
    onPageChange: async (l) => {
      const { location } = history;
      if (location.pathname.startsWith('/charts/map/')) {
        return;
      }
      // 如果没有登录，重定向到 login
      if (!initialState?.currentUser && noMenus.indexOf(location.pathname) === -1) {
        history.push(loginPath);
        // window.location.href = ssoLoginPath
        return;
      }
      if (initialState?.menus && initialState?.menus?.length > 0 && l && l?.pathname === '/') {
        const ii = findMenu(initialState?.menus, l.pathname, '');
        if (ii) {
          history.replace(ii);
        }
      }
      if (
        initialState?.menus &&
        initialState?.menus?.length > 0 &&
        noMenus.indexOf(location.pathname) === -1
      ) {
        const ii = findMenu(initialState?.menus, location.pathname, '');
        if (ii) {
          history.replace(ii);
        }
      }
      // if (initialState?.currentUser && !initialState?.menus && noMenus.indexOf(location.pathname) === -1) {
      //   const menus = await getRoutersInfo();
      //   setInitialState((preInitialState: any) => ({
      //     ...preInitialState,
      //     menus,
      //   }));
      //   history.replace({
      //     pathname: location?.pathname,
      //     search: location?.search,
      //   })
      // }
      if (
        initialState?.currentUser &&
        initialState?.menus?.length === 0 &&
        noMenus.indexOf(location.pathname) === -1
      ) {
        history.replace('/');
      }
    },
    unAccessible: <NoAccess />,
    menuHeaderRender: undefined,
    menu: {
      // 每当 initialState?.currentUser?.userid 发生修改时重新执行 request
      params: {
        userId: initialState?.currentUser?.userId,
        curOrgId: initialState?.currentUser?.curOrgId,
      },
      request: async () => {
        if (!initialState?.currentUser?.userId) {
          return [];
        }
        // initialState.currentUser 中包含了所有用户信息
        const menus = await getRoutersInfo();
        setInitialState((preInitialState: any) => ({
          ...preInitialState,
          menus,
        }));
        return menus || [];
      },
    },
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      return (
        <div>
          {children}
          {/* {!props.location?.pathname?.includes('/login') && (
            <SettingDrawer
              enableDarkTheme
              settings={initialState?.settings}
              onSettingChange={(settings) => {
                setInitialState((preInitialState: any) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )} */}
        </div>
      );
    },
    ...initialState?.settings,
    logo: Logo,
    menuProps: {
      theme: 'light',
    },
  };
};

export const antd = {
  locale: zhCN,
};
